import cx from "classnames";
import React from "react";

import { getProgramBackgroundColorPicker } from "../../helpers/useProgramColorPicker";
import { Programs } from "../../models/programsConfig";
import * as styles from "./TestStyle.module.css";

type TestButtonProps = Readonly<{
  title: string;
  url: string;
  type?: Programs;
}>;

export const TestButton = ({ title, url, type }: TestButtonProps) => {
  const styleClass = cx(
    styles.testButton,
    getProgramBackgroundColorPicker(type ?? Programs.IdXbox, true)
  );
  return (
    <div>
      <button className={styleClass} onClick={() => window.open(url, "_blank")}>
        {title}
      </button>
    </div>
  );
};
